"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Location = _interopRequireDefault(require("../geom/Location"));

var _hasInterface = _interopRequireDefault(require("../../../../hasInterface"));

var _Coordinate = _interopRequireDefault(require("../geom/Coordinate"));

var _Orientation = _interopRequireDefault(require("./Orientation"));

var _CoordinateSequence = _interopRequireDefault(require("../geom/CoordinateSequence"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var RayCrossingCounter =
/*#__PURE__*/
function () {
  function RayCrossingCounter() {
    _classCallCheck(this, RayCrossingCounter);

    RayCrossingCounter.constructor_.apply(this, arguments);
  }

  _createClass(RayCrossingCounter, [{
    key: "countSegment",
    value: function countSegment(p1, p2) {
      if (p1.x < this._p.x && p2.x < this._p.x) return null;

      if (this._p.x === p2.x && this._p.y === p2.y) {
        this._isPointOnSegment = true;
        return null;
      }

      if (p1.y === this._p.y && p2.y === this._p.y) {
        var minx = p1.x;
        var maxx = p2.x;

        if (minx > maxx) {
          minx = p2.x;
          maxx = p1.x;
        }

        if (this._p.x >= minx && this._p.x <= maxx) {
          this._isPointOnSegment = true;
        }

        return null;
      }

      if (p1.y > this._p.y && p2.y <= this._p.y || p2.y > this._p.y && p1.y <= this._p.y) {
        var orient = _Orientation.default.index(p1, p2, this._p);

        if (orient === _Orientation.default.COLLINEAR) {
          this._isPointOnSegment = true;
          return null;
        }

        if (p2.y < p1.y) {
          orient = -orient;
        }

        if (orient === _Orientation.default.LEFT) {
          this._crossingCount++;
        }
      }
    }
  }, {
    key: "isPointInPolygon",
    value: function isPointInPolygon() {
      return this.getLocation() !== _Location.default.EXTERIOR;
    }
  }, {
    key: "getLocation",
    value: function getLocation() {
      if (this._isPointOnSegment) return _Location.default.BOUNDARY;

      if (this._crossingCount % 2 === 1) {
        return _Location.default.INTERIOR;
      }

      return _Location.default.EXTERIOR;
    }
  }, {
    key: "isOnSegment",
    value: function isOnSegment() {
      return this._isPointOnSegment;
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return RayCrossingCounter;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [];
    }
  }], [{
    key: "locatePointInRing",
    value: function locatePointInRing() {
      if (arguments[0] instanceof _Coordinate.default && (0, _hasInterface.default)(arguments[1], _CoordinateSequence.default)) {
        var p = arguments[0],
            ring = arguments[1];
        var counter = new RayCrossingCounter(p);
        var p1 = new _Coordinate.default();
        var p2 = new _Coordinate.default();

        for (var i = 1; i < ring.size(); i++) {
          ring.getCoordinate(i, p1);
          ring.getCoordinate(i - 1, p2);
          counter.countSegment(p1, p2);
          if (counter.isOnSegment()) return counter.getLocation();
        }

        return counter.getLocation();
      } else if (arguments[0] instanceof _Coordinate.default && arguments[1] instanceof Array) {
        var _p = arguments[0],
            _ring = arguments[1];
        var counter = new RayCrossingCounter(_p);

        for (var i = 1; i < _ring.length; i++) {
          var p1 = _ring[i];
          var p2 = _ring[i - 1];
          counter.countSegment(p1, p2);
          if (counter.isOnSegment()) return counter.getLocation();
        }

        return counter.getLocation();
      }
    }
  }]);

  return RayCrossingCounter;
}();

exports.default = RayCrossingCounter;

RayCrossingCounter.constructor_ = function () {
  this._p = null;
  this._crossingCount = 0;
  this._isPointOnSegment = false;
  var p = arguments[0];
  this._p = p;
};